export var AttachmentFileType;
(function (AttachmentFileType) {
    AttachmentFileType[AttachmentFileType["Base64InlineImage"] = 0] = "Base64InlineImage";
    AttachmentFileType[AttachmentFileType["Cloud"] = 1] = "Cloud";
    AttachmentFileType[AttachmentFileType["Local"] = 2] = "Local";
    AttachmentFileType[AttachmentFileType["MailItem"] = 3] = "MailItem";
    AttachmentFileType[AttachmentFileType["Uri"] = 4] = "Uri";
    AttachmentFileType[AttachmentFileType["AttachmentItem"] = 5] = "AttachmentItem";
})(AttachmentFileType || (AttachmentFileType = {}));
//# sourceMappingURL=AttachmentFile.js.map